import { NgModule, ModuleWithProviders } from '@angular/core';
import {
    ModelValidationMetadataMap,
    VALIDATION_ENTITY_METADATA,
} from './validation-metadata';
import { defaultValidatorProviders } from './default-validators';

export interface ValidationModuleConfig {
    validationMetadata: ModelValidationMetadataMap[];
}

@NgModule({
    providers: [defaultValidatorProviders],
})
export class ValidationModule {
    static forRoot(
        config: ValidationModuleConfig
    ): ModuleWithProviders<ValidationModule> {
        return {
            ngModule: ValidationModule,
            providers: [
                {
                    provide: VALIDATION_ENTITY_METADATA,
                    useValue: config.validationMetadata || [],
                    multi: true,
                },
            ],
        };
    }
}
